import React, { ReactElement } from "react";
import MainBanner from "@components/topcommercialcleaners/mainBanner/mainBanner";
import TopCommercialCleanersWrapper from "@components/layouts/topcommercialcleanersWrapper";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";

const OffersList = dynamic(() => import("@components/shared/offersList"));

const WhyUs = dynamic(() => import("@components/topcommercialcleaners/whyUs"));

export default function TopCommercialCleanersHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <TopCommercialCleanersWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <WhyUs />
        </TopCommercialCleanersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
